import React from 'react'
import { Box, Link, ShowIf } from '@ztechapps/webui.util'
import { PasswordlessAuthLayout } from './PasswordlessAuthLayout'
import { Stack, Tab, Tabs } from 'react-bootstrap'
import { RegisterForm } from './registerForm'
import { BasicAuthLayout } from './BasicAuthLayout'
import { LoginOverview } from '../../../components/login-overview'

enum LoginMethod {
  PASSWORDLESS = 'passwordless',
  BASIC = 'basic',
  GOOGLE_OAUTH = 'google_oauth',
}

export default function Login() {
  const [loginMethod, setLoginMethod] = React.useState<LoginMethod>(LoginMethod.BASIC)

  return (
    <LoginOverview>
      <Tabs variant="underline" id="loginFormTab" defaultActiveKey={1}>
        <Tab eventKey={1} title="Login">
          <div className="py-3">
            <Box>
              <Box.Body>
                <Stack gap={3}>
                  <ShowIf condition={loginMethod === LoginMethod.PASSWORDLESS}>
                    <div>
                      <PasswordlessAuthLayout />
                    </div>
                  </ShowIf>

                  <ShowIf condition={loginMethod === LoginMethod.BASIC}>
                    <div>
                      <BasicAuthLayout />
                    </div>
                  </ShowIf>

                  <div>
                    <div className="fw-bold">Try other login method</div>
                  </div>

                  <div>
                    <Stack gap={1}>
                      <ShowIf condition={loginMethod !== LoginMethod.BASIC}>
                        <Link onClick={() => setLoginMethod(LoginMethod.BASIC)}>With UserName & Password Login</Link>
                      </ShowIf>
                      <ShowIf condition={loginMethod !== LoginMethod.PASSWORDLESS}>
                        <Link onClick={() => setLoginMethod(LoginMethod.PASSWORDLESS)}>With Passwordless Login</Link>
                      </ShowIf>
                      <Link href="/api/auth/google">With Google Login</Link>
                    </Stack>
                  </div>
                </Stack>
              </Box.Body>
            </Box>
          </div>
        </Tab>
        <Tab eventKey={2} title="Register">
          <div className="py-3">
            <Box>
              <Box.Body>
                <RegisterForm />
              </Box.Body>
            </Box>
          </div>
        </Tab>
      </Tabs>
    </LoginOverview>
  )
}
